import { FeatureCategory } from '../types';

export const activitiesFeatures: FeatureCategory = {
  name: "Activities & Enrichment",
  icon: "Gamepad2",
  features: [
    { 
      name: "Fitness Videos", 
      description: "Access to guided fitness videos designed for seniors, including chair exercises, gentle yoga, and balance training.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "Activity Logging", 
      description: "Track daily activities, exercise, hobbies, and social engagement to monitor overall wellness and activity levels.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "Brain Games", 
      description: "Cognitive exercises and brain training games designed to maintain mental sharpness and memory.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    { 
      name: "Hobbies & Interests", 
      description: "Explore and track personal hobbies and interests with resources, communities, and activity suggestions.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    {
      name: "My Garden",
      description: "AI plant identifier, seasonal care guides, Plant of the Week, gardening videos, photo journal, watering reminders synced to your calendar, and a personal plant collection you can save and track.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    {
      name: "Book Explorer",
      description: "Discover new books, track reading progress, and access book recommendations tailored to your interests.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "👁"
    },
    {
      name: "Recipes & Nutrition",
      description: "Browse recipes designed for easy preparation, explore nutrition guidance, and discover meals that match dietary needs.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "👁"
    },
    {
      name: "My Pet",
      description: "Keep track of pet care, vet visits, and daily routines, because furry companions are part of thriving at home.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "👁"
    }
  ]
};
